import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

const TemplateInfo = ({ templateData }) => {
	const { dict } = useSelector((state) => state.app);
	const { categoriesDict } = useSelector((state) => state.data);

	const getDateSpan = useCallback((dateString) => {
		if (!dateString || dateString.length < 1) return '';
		return (
			<span style={ { whiteSpace: 'nowrap' } }>
				{dateString.replace('T', ', ').replaceAll('-', '.')}
			</span>
		);
	}, []);
    
	return (       
		<section className='letter__info'>
			{templateData && (
				<div className='letter__info--inner'>
					<div className='letter__info--bar'>
						{templateData.owner && (
							<div className='letter__info--item'>
								{dict.templates.info.owner}<span>&nbsp;{`${templateData.owner.forename} ${templateData.owner.surname}`}</span>
							</div>
						)}
						{templateData.department.name && (
							<div className='letter__info--item'>
								{dict.letter.info.department}<span>{templateData.department.name}</span>
							</div>)}
						{templateData.category && (
							<div className='letter__info--item'>
								{dict.letter.categories.category}:
								<span> {categoriesDict[templateData.category.code]}</span>
							</div>
						)}
					</div>

					<div className='letter__info--bar right'>
						<div className='letter__info--item'>
							{dict.letter.info.addDate}
							{getDateSpan(templateData.createdOn)}
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.editDate}{getDateSpan(templateData.modifiedOn)}
						</div>

					</div>
				</div>

			)}

		</section>
	);
};
export default React.memo(TemplateInfo);